import {
  Button, Icon, IconButton, Input, InputGroup, InputRightElement, SimpleGrid,
} from '@chakra-ui/react';
import { useState } from 'react';
import { produce } from 'immer';
import { FaRegTrashAlt } from 'react-icons/fa';
import useUpdateField from '../useUpdateField';

const OptionsList = ({ field }) => {
  const [state, setState] = useUpdateField(field, 'props.options', []);
  const [newOption, setOptionValue] = useState('');

  const onChange = (idx, e) => {
    const { value } = e.target;
    setState((prev) => {
      const v = [...prev];
      v[idx] = { key: value, value };
      return v;
    });
  };

  const handleAddNewOption = () => {
    setState((prev) => [...prev, { key: newOption, value: newOption }]);
    setOptionValue('');
  };

  const handleRemoveOption = (id) => {
    const newValues = produce((draft) => {
      draft.splice(id, 1);
    });
    setState(newValues);
  };

  return (
    <SimpleGrid columns={1} gap={1}>
      {state.map((option, idx) => (
        <InputGroup size="sm" key={idx}>
          <Input value={option.value} onChange={(e) => onChange(idx, e)} />
          <InputRightElement width="4.5rem">
            <IconButton
              h="1.5rem"
              size="sm"
              icon={<Icon as={FaRegTrashAlt} boxSize={3} color="gray.600" />}
              variant="ghost"
              onClick={() => handleRemoveOption(idx)}
            />
          </InputRightElement>
        </InputGroup>
      )) }
      <InputGroup size="sm">
        <Input
          placeholder="New option"
          value={newOption}
          onChange={(e) => setOptionValue(e.target.value)}
        />
        <InputRightElement width="4.5rem">
          <Button
            h="1.5rem"
            size="sm"
            onClick={handleAddNewOption}
            isDisabled={newOption.length === 0 || state.find((f) => f.key === newOption)}
          >
            Add
          </Button>
        </InputRightElement>
      </InputGroup>
    </SimpleGrid>
  );
};

export default OptionsList;
